import { createAction, props } from "@ngrx/store";
import { BIGTransit } from "src/model/class/telegram classes/big-transit";
import { AccessResult } from "src/components/shared-components/enum/enumAccessControl";
import { HistoryTransitStoreAction } from "src/components/shared-components/enum/enumStoreAction";
import { HistoryTransit } from "src/model/interface/history-transit";

/**
 * Action to add new transit in history transit list
 */
export const historyTransitAddNewTransitAction = createAction(
  HistoryTransitStoreAction.HISTORY_TRNASIT_START_ADD_NEW_TRANSIT_IN_HISTORY,
  props<{
    idDevice: number;
    instanceGuid: string;
    address: string;
    code: string;
    accessResult: AccessResult;
    uid: string;
  }>()
);

/**
 * Action to complete transit history transit history
 */
export const historyTransitCompleteAddNewTransitInHistoryAction = createAction(
  HistoryTransitStoreAction.HISTORY_TRNASIT_COMPLETE_ADD_NEW_TRANSIT_IN_HISTORY,
  props<{
    historyTransit: HistoryTransit;
  }>()
);

/**
 * Action to remove existing transit in history transit list
 */
export const historyTransitRemoveExistingTransitAction = createAction(
  HistoryTransitStoreAction.HISTORY_TRNASIT_REMOVE_EXISTING_TRANSIT,
  props<{
    idPlant: number;
    idDevice: number;
    serverConfirmationTelegram: string;
  }>()
);

/**
 * Action to remove history transit releated to removed plant
 */
export const historyTransitRemoveHistoryTransitReleatedToRemovedPlantAction =
  createAction(
    HistoryTransitStoreAction.HISTORY_TRANSIT_REMOVE_PLANT_REMOVE_RELEATED_HISTORY,
    props<{
      idPlant: number;
    }>()
  );
